import React, { createContext, useState, useContext, ReactNode, useCallback } from 'react';

interface ModalContextType {
  isGetStartedModalOpen: boolean;
  openGetStartedModal: () => void;
  closeGetStartedModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isGetStartedModalOpen, setIsGetStartedModalOpen] = useState(false);

  const openGetStartedModal = useCallback(() => {
    setIsGetStartedModalOpen(true);
  }, []);

  const closeGetStartedModal = useCallback(() => {
    setIsGetStartedModalOpen(false);
  }, []);

  return (
    <ModalContext.Provider value={{ isGetStartedModalOpen, openGetStartedModal, closeGetStartedModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
}; 